/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSliderSwiper from 'base/components/standalone/Slider/Swiper';

export const DynamicStandaloneSliderSwiper = StandaloneSliderSwiper;
export type DynamicStandaloneSliderSwiperProps = PropsFromComponent<typeof StandaloneSliderSwiper>;

export const DynamicStandaloneSliderSwiperWith = (extras: DynamicStandaloneExtras): typeof StandaloneSliderSwiper => {
    return function DynamicStandaloneSliderSwiper(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SliderSwiper');
        return <StandaloneSliderSwiper {...mergeProps({ options: { theme } }, props)} />;
    }
}